import {
  computeBDR,
  computeDiffPct10dp,
  computeDiffValue,
  computeHLVessel,
} from '../../computations/labComputations'
import { fmt, fmtPct } from '../../../../robFormatUtils'
import { useFormContext, useWatch } from 'react-hook-form'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import './labHLVesselSection.less'

const ReadOnlyCell = ({ value }) => (
  <span className="lab-hl__value">{value}</span>
)

ReadOnlyCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

const HL_ROWS = [
  { key: 'volume15', labelKey: 'rob.survey.bunker.lab.hlVessel.volume15' },
  { key: 'density15', labelKey: 'rob.survey.bunker.lab.hlVessel.density15' },
  {
    key: 'specGravity',
    labelKey: 'rob.survey.bunker.lab.hlVessel.specGravity',
  },
  { key: 'massMtVac', labelKey: 'rob.survey.bunker.lab.hlVessel.massMtVac' },
  {
    key: 'weightMtAir',
    labelKey: 'rob.survey.bunker.lab.hlVessel.weightMtAir',
  },
]

const LabHLVesselSection = () => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const bdnDensity15 = useWatch({ control, name: 'bunker.bdn.density15' })
  const bdnVolume15 = useWatch({ control, name: 'bunker.bdn.volume15' })
  const vslVolume15 = useWatch({ control, name: 'bunker.volume15CPerVsl' })
  const labDensity15 = useWatch({ control, name: 'laboratory.tests.density15' })

  const bdrValues = computeBDR(bdnDensity15, bdnVolume15)
  const hlValues = computeHLVessel(labDensity15, vslVolume15)

  return (
    <div className="lab-card">
      {/* Four-column header: title | Surveyor | Diff. to BDR | Percent % */}
      <div className="lab-card__header lab-hl-header">
        <span className="lab-hl-header__title">
          {t('rob.survey.bunker.lab.hlVessel.title')}
        </span>
        <span className="lab-hl-header__col">
          {t('rob.survey.bunker.lab.hlVessel.surveyorHeader')}
        </span>
        <span className="lab-hl-header__col">
          {t('rob.survey.bunker.lab.hlVessel.diffBdrHeader')}
        </span>
        <span className="lab-hl-header__col">
          {t('rob.survey.bunker.lab.hlVessel.percentHeader')}
        </span>
      </div>

      <div className="lab-card__body">
        {HL_ROWS.map(({ key, labelKey }) => {
          const surveyorVal = hlValues?.[key] ?? null
          const bdrVal = bdrValues?.[key] ?? null
          const diffVal = computeDiffValue(surveyorVal, bdrVal)
          const pctVal = computeDiffPct10dp(surveyorVal, bdrVal)

          return (
            <div className="lab-hl__row" key={key}>
              <span className="lab-hl__label">{t(labelKey)}</span>
              <ReadOnlyCell value={fmt(surveyorVal)} />
              <ReadOnlyCell value={fmt(diffVal)} />
              <ReadOnlyCell value={fmtPct(pctVal)} />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LabHLVesselSection
